import { get } from "@/apis";
import router from "@/router";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    signLocationId: 0, // 选中签到点Id,加载签到点配置
    IsTheLinkValid: false,
    IsActivityRenderingCompleted: false, // 活动是否渲染完成
    IsSignRenderingCompleted: false, // 签到配置信息是否渲染完成
    // 活动的配置信息
    doings: {
      id: 0,
      name: "",
      activityId: 0,
      banner: "",
      footer: "",
      beginTime: "",
      endTime: "",
    },
    // 签到配置信息
    config: {
      id: 0,
      activityId: 0,
      displayAppSettings: [],
      displayPcSettings: {},
      modalSettings: {},
      ruleSettings: {},
      signinLocation: {},
      signinMode: 0,
    },
  },
  mutations: {
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_DOINGS(state, payload) {
      state.doings = payload;
    },
    SET_ACTIVITY_RENDERING_COMPLETED(state) {
      state.IsActivityRenderingCompleted = true;
    },
    SET_SIGN_RENDERING_COMPLETED(state) {
      state.IsSignRenderingCompleted = true;
    },
    SET_THE_LINK_VALID(state) {
      state.IsTheLinkValid = true;
    },
  },
  getters: {
    getConfig: (state) => {
      return state.config;
    },
    getDoings: (state) => {
      return state.doings;
    },
    getBanner: (state) => {
      return state.config.banner || false;
    },
    getFooter: (state) => {
      return state.config.footer || false;
    },
    getIsActivityRenderingCompleted: (state) => {
      return state.IsActivityRenderingCompleted;
    },
    getIsSignRenderingCompleted: (state) => {
      return state.IsSignRenderingCompleted;
    },
    getIsTheLinkValid: (state) => {
      return state.IsTheLinkValid;
    },
  },
  actions: {
    // 加载活动信息
    async setDoings(context, data) {
      message.open({
        content: "背景加载中...",
        type: "loading",
        duration: 1,
      });

      const { alias } = data;
      const res = await get(
        `/api/SigninConfig/GetActivityConfigByAlias/${alias}`
      );
      if (res.code === 200 && res.success) {
        context.commit("SET_DOINGS", res.data);
      } else {
        router.push(`/error?title=${res.code}&msg=${res.message}`);
      }
    },
    async setConfig(context, data) {
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });

      const { configuration } = data;
      const res = await get(
        `/api/SigninConfig/GetSignConfigById/${configuration}`
      );
      if (res.code === 200 && res.success) {
        context.commit("SET_CONFIG", res.data);
      }
    },
    setIsActivityRenderingCompleted(context) {
      context.commit("SET_ACTIVITY_RENDERING_COMPLETED");
    },
    setIsSignRenderingCompleted(context) {
      context.commit("SET_SIGN_RENDERING_COMPLETED");
    },
  },
};
